import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  step1: {
    name: "",
    country_id: "",
    city_id: null,
    address: "",
    phone: "",
    latitude: null,
    longitude: null,
    product_type_id: 2, // hosting
    hosting_type_id: null,
    number_of_travelers: 1,
    number_of_rooms: 1,
    number_of_bed: 1,
    number_of_bath_rooms: 1,
  },

  step2: {
    short_summary: "",
    detailed_description: "",
    key_points: [],
    keyword: [],
    equipment: [],
  },

  step3: {
    booking_confirmation_mode: "",
    cancellation_policy_id: "",
    cutoff_time_booking_value: null,
    cutoff_time_booking_unit: "minutes",
    start_date: "",
    end_date: "",
    pricing: {
      price: 0,
      applicable_days: [],
    },
    charge_service: "",
    charge_service_type: "",
  },
};

// Deep update helper (supports dot notation)
function deepUpdate(obj, field, value) {
  if (obj && typeof obj === "object") {
    if (field in obj) {
      obj[field] = value;
      return true;
    }
    for (const key of Object.keys(obj)) {
      if (deepUpdate(obj[key], field, value)) return true;
    }
  }
  return false;
}

const productHostingSlice = createSlice({
  name: "productHosting",
  initialState,
  reducers: {
    updateHostingStepField: (state, action) => {
      const { field, value } = action.payload;

      if (typeof field !== "string") {
        console.error("updateHostingStepField: invalid field", field);
        return;
      }

      // Dot notation support
      if (field.includes(".")) {
        const keys = field.split(".");
        let target = state;
        for (let i = 0; i < keys.length - 1; i++) {
          if (!target[keys[i]]) return;
          target = target[keys[i]];
        }
        target[keys[keys.length - 1]] = value;
        return;
      }

      // Deep search fallback
      if (!deepUpdate(state, field, value)) {
        console.warn(`Field '${field}' not found in state`);
      }
    },

    updateSection: (state, action) => {
      const { section, data } = action.payload;
      if (state[section]) {
        Object.assign(state[section], data);
      }
    },

    resetHostingProduct: () => initialState,
  },
});

export const { updateHostingStepField, updateSection, resetHostingProduct } =
  productHostingSlice.actions;

export default productHostingSlice.reducer;
